module.exports = __webpack_public_path__ + "img/help1.4c7d5aab.png";